<script setup lang="ts">
/**
 * Final Dividends — Representative Minutes (s.179(6)) (Sole Corporate Member).
 *   원본: Representative Minutes (s179(6)) – Final Dividends (Sole Corporate Member).
 *   지주회사 대표자가 자회사 EGM 결의를 확인. 서명 없음 — 밑줄 + [[Corporate_Representative_Name]].
 */
import CddVarField from '../cdd/CddVarField.vue';
import './agmDoc.css';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
      <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the &ldquo;Company&rdquo;)</div>
    </div>

    <div class="doc-title">MINUTES BY REPRESENTATIVE OF HOLDING COMPANY</div>
    <div class="doc-sub">RELATING TO PROCEEDINGS OF SUBSIDIARY COMPANY UNDER</div>
    <div class="doc-sub">SECTION 179(6) OF THE COMPANIES ACT 1967</div>

    <p class="doc-p">
      I, <CddVarField field-key="corporate_representative_name" label="Corporate Representative Name" />, the undersigned, the duly appointed
      representative of <CddVarField field-key="holding_company_name" label="Holding Company Name" />, the holding company beneficially entitled
      to the whole of the issued share capital of the company, hereby confirm that the Extraordinary General Meeting of the Company was
      deemed held on <CddVarField field-key="meeting_date" label="Meeting Date" /> at <CddVarField field-key="meeting_time" label="Meeting Time" />
      and that the following resolutions was duly passed pursuant to Section 179(6) of the Companies Act 1967:-
    </p>

    <div class="sec-title" style="text-align:center">FINAL DIVIDEND</div>
    <p class="doc-p">
      NOTED THAT the Company has sufficient profits for the declaration of a final dividend of
      <CddVarField field-key="dividend_amount" label="Dividend Amount" /> to its member.
    </p>
    <p class="doc-p">
      RESOLVED THAT a final one-tier tax exempt dividend of <CddVarField field-key="dividend_amount" label="Dividend Amount" />
      in respect of the financial year ended <CddVarField field-key="financial_year_end" label="Financial Year End" />
      and is hereby approved for payment out of the profits of the Company to the member whose names appear on the Register of Members as follows:-
    </p>

    <table class="cdd-tbl">
      <thead><tr><th>Member</th><th>Amount</th></tr></thead>
      <tbody>
        <tr><td><CddVarField field-key="member_name" label="Member Name" /></td><td><CddVarField field-key="dividend_amount" label="Dividend Amount" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p">Signed as a correct record,</p>
    <div class="sign-line"></div>
    <p class="doc-p">
      <CddVarField field-key="corporate_representative_name" label="Corporate Representative Name" /><br />
      (Corporate Representative of <CddVarField field-key="holding_company_name" label="Holding Company Name" />)
    </p>
  </div>
</template>
